<template>
  <div class="business-plan-activity pt-2 pt-3-lg">
    <div
      v-if="activeUsers !== null && showActiveUsers"
      class="text-center mb-3"
    >
      There
      {{ activeUsers === 1 ? 'is 1 agent' : `are ${activeUsers} people` }}
      prospecting right now.
    </div>
    <b-card
      v-for="activity in activities"
      :key="activity.id"
      class="mb-1"
    >
      <div
        v-if="activity.type === 'Joining'"
        class="media mb-0 align-items-center"
      >
        <div class="media-left">
          <span
            class="profile-img smaller mr-3"
            :style="`background-image:url(${activity.user.image})`"
          ></span></div>
        <div class="media-body">
          <b>{{ activity.user.name }}</b>
          joined Business Planning.
        </div>
      </div>
      <div
        v-if="activity.type === 'Leaving'"
        class="media mb-0 align-items-center"
      >
        <div class="media-left line-height-0">
          <span
            class="profile-img smaller mr-3"
            :style="`background-image:url(${activity.user.image})`"
          ></span>
        </div>
        <div class="media-body">
          <b>{{ activity.user.name }}</b>
          left Business Planning.
        </div>
      </div>
      <div
        v-if="activity.type === 'App\\Notifications\\LiveStreamStarted'"
      >
        <a
          :href="urls.businessPlan.showVideo(activity.video.id)"
          class="d-block alert alert-info mb-0 text-decoration-none border-0 text-center"
        >
          <b>{{ activity.video.title }}</b>
          is live in business planning!
          <span class="text-underline font-weight-bold">Join Now</span>
        </a>
      </div>
      <div
        v-else
        class="media mb-0 align-items-center"
      >
        <div class="media-left line-height-0">
          <span
            class="profile-img smaller mr-3"
            :style="`background-image:url(${activity.owner ? activity.owner.image : ''})`"
          ></span>
        </div>
        <div class="media-body">
          <span
            v-if="activity.engagement.type === 'App\\Engagements\\Simple\\Conversation'"
          >
            <b>{{ activity.owner.name }}</b>
            had a conversation.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\Appointment'"
          >
            <b>{{ activity.owner.name }}</b>
            made an appointment from their {{ activity.engagement.lead_source }}.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\LandlordRepAppointment'"
          >
            <b>{{ activity.owner.name }}</b>
            made an appointment from their {{ activity.engagement.lead_source }}.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\TenantRepAppointment'"
          >
            <b>{{ activity.owner.name }}</b>
            made an appointment from their {{ activity.engagement.lead_source }}.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\ListingAgreement'"
          >
            <b>{{ activity.owner.name }}</b>
            signed a listing agreement from their {{ activity.engagement.lead_source }}.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\BuyerAgreement'"
          >
            <b>{{ activity.owner.name }}</b>
            signed a buyer agreement from their {{ activity.engagement.lead_source }}.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\BuyerConsultation'"
          >
            <b>{{ activity.owner.name }}</b>
            gave a buyer consultation from their {{ activity.engagement.lead_source }}.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\OpenHouse'"
          >
            <b>{{ activity.owner.name }}</b>
            held an open house.
          </span>
          <span
            v-else-if="activity.engagement.type === 'App\\Engagements\\Simple\\Outbound'"
          >
            <b>{{ activity.owner.name }}</b>
            made a referral.
          </span>
          <span
            v-else
          >
            {{ activity.summary }}
          </span>
        </div>
      </div>
    </b-card>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import $ from 'jquery'
import urls from '@/api/urls'
import { getRecentBusinessPlanActivity } from '@/api'

const $window = $(window)

export default {
  props: {
    isAgent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activities: [],
      activeUsers: null,
      urls
    }
  },
  computed: {
    isMobile () {
      return $window.width() < 992
    },
    showActiveUsers () {
      return !this.isAgent || (this.activeUsers !== null && this.activeUsers >= 20)
    }
  },
  async mounted () {
    try {
      let recent = await getRecentBusinessPlanActivity()
      this.activities = recent.data.data
    } catch (e) {
      // ignore
    }

    window.Echo.join('BusinessPlan')
      .here((users) => {
        this.activeUsers = users.length
      })
      .joining((user) => {
        this.activeUsers++
        this.addActivity({
          type: 'Joining',
          user
        })
      })
      .leaving((user) => {
        this.activeUsers--
        this.addActivity({
          type: 'Leaving',
          user
        })
      })

    window.Echo.private('BusinessPlan')
      .notification((notification) => {
        this.addActivity(notification)
      })
  },
  methods: {
    addActivity (activity) {
      //console.log(activity)
      this.activities.unshift(activity)
      if (this.activities.length > 100) {
        this.activities.pop()
      }
    }
  }
}
</script>